// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonthlyLimitInfoAPIModel
 */
export interface MonthlyLimitInfoAPIModel {
    /**
     * 
     * @type {string}
     * @memberof MonthlyLimitInfoAPIModel
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof MonthlyLimitInfoAPIModel
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof MonthlyLimitInfoAPIModel
     */
    currentAmount: string;
    /**
     * 
     * @type {string}
     * @memberof MonthlyLimitInfoAPIModel
     */
    assetId: string;
    /**
     * 
     * @type {Date}
     * @memberof MonthlyLimitInfoAPIModel
     */
    updatedAt: Date;
}

export function MonthlyLimitInfoAPIModelFromJSON(json: any): MonthlyLimitInfoAPIModel {
    return MonthlyLimitInfoAPIModelFromJSONTyped(json, false);
}

export function MonthlyLimitInfoAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonthlyLimitInfoAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'amount': json['amount'],
        'currentAmount': json['currentAmount'],
        'assetId': json['assetId'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function MonthlyLimitInfoAPIModelToJSON(value?: MonthlyLimitInfoAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'amount': value.amount,
        'currentAmount': value.currentAmount,
        'assetId': value.assetId,
        'updatedAt': (value.updatedAt.toISOString()),
    };
}


